/*---------------------------------------------------------*\
 * Imports
\*---------------------------------------------------------*/

/*---------------------------------------------------------*\
 * WeakMaps
\*---------------------------------------------------------*/
const deps = {};

/*---------------------------------------------------------*\
 * TrafficController
\*---------------------------------------------------------*/
class TrafficController {
  //-----------------------------------
  // Constructor
  //-----------------------------------
  constructor(localService, storageKeys) {
    deps.localService = localService;
    deps.storageKeys = storageKeys;

    this.name = 'traffic';
    this.headerConfig = {};
    this.currentRegion = localService.get(storageKeys.selectedRegion);
  }

  //-----------------------------------
  // Properties
  //-----------------------------------
  get region() {
    const _region = deps.localService.get(deps.storageKeys.selectedRegion);
    return _region ? _region.abbr : 'LI';
  }

  //-----------------------------------
  // Methods
  //-----------------------------------
}

TrafficController.$inject = [
  'localService',
  'storageKeys'
];

export default TrafficController;



/** WEBPACK FOOTER **
 ** ./client/app/components/traffic/traffic.controller.js
 **/